// extracted by mini-css-extract-plugin
export default {"docrequirements":"documentUpload_docrequirements__1qpns"};